import axios from "axios"
import baseURL from "../configs/api"

export const put_GeneralSetting = (data: any, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}generalSetting?userId=${userId}`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            'Content-Type': 'application/json'
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const getLatestGeneralSettingWithTimeZoneValue = (tenantId: string) => {
    return getFetch("generalSetting/GetLatestGeneralSettingWithTimeZoneValue", tenantId)
}

export const getGeneralSettings = (tenantId: string) => {
    return getFetch("generalSetting", tenantId)
}

export const getGeneralSetting = (primaryKey: string, tenantId: string) => {
    return getFetch(`generalSetting/${primaryKey}`, tenantId)
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
            'Content-Type': 'application/json'
        },
        params: params
    }).then(response => response.data);
}